import { useMediaQueries } from '~coreModules/core/js/composables/useMediaQueries';

/* eslint-disable no-param-reassign */
export default {
    install: function install(app) {
        // Install a reactive $mediaQueries on the root component
        app.config.globalProperties.$mediaQueries = useMediaQueries();
    },
};
